import React from 'react';
import { motion } from 'framer-motion';
import { formatRelativeTime } from '@/utils/date';
import type { Comment } from '@/types/blog';

interface CommentListProps {
  comments: Comment[];
}

export const CommentList: React.FC<CommentListProps> = ({ comments }) => {
  return (
    <div className="space-y-4">
      {comments.map((comment, index) => (
        <motion.div
          key={comment.id}
          className="glass p-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
        >
          <div className="flex items-center justify-between mb-2">
            <div className="text-sm text-neon-green">
              {comment.user?.email || 'Anonymous'}
            </div>
            <div className="text-xs text-gray-400">
              {formatRelativeTime(comment.created_at)}
            </div>
          </div>
          <p className="text-sm text-gray-200">{comment.content}</p>
        </motion.div>
      ))}
    </div>
  );
};